module.exports = __webpack_public_path__ + "media/WR Blob 4.bc0377d8.mp3";